import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import Link from './Link';
import InlineSvg from './InlineSvg';
import { useState } from 'react';
import useIntersectionObserver from '../helpers/useIntersectionObserver';
import IconCardRowNoodles from './IconCardRowNoodles';

const IconCardsRow = (props) => {
  const { heading, cards, theme } = props;
  const [gradientPositionX, setGradientPositionX] = useState(40);
  const [gradientPositionY, setGradientPositionY] = useState(20);

  const sectionRef = useRef();
  const dataRef = useIntersectionObserver(sectionRef, {
    freezeOnceVisible: false,
    rootMargin: '-50% 0px -50%',
  });

  // TODO: better way to handle this
  // * only changes when intersecting changes... can't wrap my head around why
  useEffect(() => {
    if (dataRef?.isIntersecting) {
      setGradientPositionX(-100);
      setGradientPositionY(30);
    } else {
      setGradientPositionX(40);
      setGradientPositionY(20);
    }
  }, [dataRef?.isIntersecting]);

  return (
    <section className={classNames('icon-cards-row__root', `icon-cards-row__theme-${theme}`)} ref={sectionRef}>
      <div className={classNames("ui container",{
              'icon-cards-row__no-heading': !heading,
            })}>
        <div className="grid-wrapper">
          {/* // TODO: don't display these when there's no heading? */}
          <div
            className='icon-cards-row__container'
          >
            {heading ? (
              <div className="icon-cards-row__heading">
                <h2 className="heading-one">{heading}</h2>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="icon-cards-row__cards-wrapper">
        <IconCardRowNoodles
          theme={theme}
          gradientPositionX={gradientPositionX}
          gradientPositionY={gradientPositionY}
        />
        <div className="ui container">
          <div className="grid-wrapper">
            <div className="icon-cards-row__cards">
              {/* If the looped element gets too complex, it should be moved into it's own component file */}
              {cards?.map((card, i) => {
                const linkUrl = card.cardLink?.url ? card.cardLink?.url : '/';
                return (
                  <Link
                    to={linkUrl}
                    target={card.cardLink?.target}
                    className="icon-cards-row__card"
                    key={i}
                    forceUseAnchorTag
                  >
                    {card.cardIcon?.sourceUrl ? (
                      <div className="icon-cards-row__card-icon-wrapper">
                        <img
                          src={card.cardIcon.sourceUrl}
                          className="icon-cards-row__cardIcon"
                          alt={card.cardIcon?.altText || card.cardTitle}
                        />
                      </div>
                    ) : null}
                    <p className="icon-cards-row__cardTitle body-one">
                      <span className="icon-cards-row__cardTitle--lineLimit">{card.cardTitle}</span>
                    </p>
                    <InlineSvg
                      name="arrow"
                      color="red"
                      className="icon-cards-row__cardArrow"
                    />
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IconCardsRow;
